export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/enIcon.065e0122.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};